import CustomDrawer from "@/components/drawer";
import { ReactNode, useCallback, useRef } from "react";
import classes from "./sms.module.scss";

type Props = {
  opened: boolean;
  onClose: () => void;
  // Hash key, so the phone's back button closes the sheet.
  name: string;
  title: ReactNode;
  children: ReactNode;
  // Long pickers fill most of the screen; short action sheets fit their content.
  tall?: boolean;
};

export default function BottomSheet({ opened, onClose, name, title, children, tall }: Props) {
  // CustomDrawer re-runs its hash check whenever `close` changes identity (and calls it when the hash
  // doesn't match), so it must get a stable function.
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  const close = useCallback(() => onCloseRef.current(), []);

  return (
    <CustomDrawer
      opened={opened}
      onClose={close}
      close={close}
      custom={name}
      position="bottom"
      dir="rtl"
      title={<span className={classes.sheetTitle}>{title}</span>}
      styles={{
        content: tall
          ? { height: "calc(100% - 44px)", display: "flex", flexDirection: "column" }
          : { height: "auto", maxHeight: "calc(100% - 40px)" },
        // A tall sheet's body fills the rest, so a footer inside it can sit at the bottom.
        body: tall ? { direction: "rtl", flex: 1, minHeight: 0, overflowY: "auto", display: "flex", flexDirection: "column" } : { direction: "rtl" },
        header: { direction: "rtl" },
      }}
    >
      {children}
    </CustomDrawer>
  );
}
